import { api, apiNoTokenAWS } from './apis';

export function getVaccineTypes() {
  return api.get('kin/content/v1/vaccines.json');
}

export function uploadDocument(petId, formData) {
  return api.post(`/baas/documents/${petId}/vet_records/`, formData);
}

export async function getProfileByEmail (
  email,
) {
  return await api.get(`baas/users/email/${encodeURIComponent(email)}`, {
    params: {
      isFullProfile: true,
    },
  });
}

export async function getProfileByOwnerKinshipId (
  ownerKinshipId,
) {
  return await apiNoTokenAWS.get(`baas/user_profile/${ownerKinshipId}`, {
    params: {
      isFullProfile: true,
    },
  });
}